import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                      */
function LocationDistance({ className, distance, labels, timeByCar, timeByFoot, ...rest }) {
  const isEmpty = !(distance || timeByCar || timeByFoot);
  if (isEmpty) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: classnames("location-distance", className), ...rest }, /* @__PURE__ */ React.createElement("div", { className: "location-distance__content" }, distance && /* @__PURE__ */ React.createElement("div", { className: "location-distance__item" }, /* @__PURE__ */ React.createElement(Text, { className: "location-distance__text", component: "span", variant: "body-head" }, labels.distance)), timeByFoot && /* @__PURE__ */ React.createElement("div", { className: "location-distance__item" }, /* @__PURE__ */ React.createElement(Icon, { name: "walking" }), /* @__PURE__ */ React.createElement("span", { className: "location-distance__visually-hidden" }, labels.walking), /* @__PURE__ */ React.createElement(Text, { className: "location-distance__text", component: "span" }, timeByFoot)), timeByCar && /* @__PURE__ */ React.createElement("div", { className: "location-distance__item" }, /* @__PURE__ */ React.createElement(Icon, { name: "driving" }), /* @__PURE__ */ React.createElement("span", { className: "location-distance__visually-hidden" }, labels.driving), /* @__PURE__ */ React.createElement(
    Text,
    {
      className: "location-distance__text location-distance__text--space",
      component: "span"
    },
    timeByCar
  ))));
}
const LocationDistance$1 = React.memo(LocationDistance);
export {
  LocationDistance$1 as default
};
//# sourceMappingURL=LocationDistance.js.map
